import { observable, computed, action } from 'mobx';

class ListView {
	@observable page = 0;
	@observable count = 20;

	@action addPage = () => {
	  this.page ++;
	};

	@computed get getPage () {
		return this.page;
	}

	@computed get getCount () {
		return this.count;
	}
}

export default ListView
